import React from 'react'
import BoardContainer from './BoardContainer'

export default class Home extends React.Component {
  state={}
  componentDidMount() {
  }
  render() {
    const {match} = this.props
    const {params} = match
    const {slug} = params
    return (
      <div className="main-content">
        <BoardContainer slug={slug} />
      </div>
    )
  }
}
